var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 201 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M138.12 116.648a63.33 63.33 0 0 0 23.134-70.823 63.334 63.334 0 1 0-97.374 70.823 90.02 90.02 0 0 0-52.88 82h20a69.998 69.998 0 0 1 119.497-49.497A70 70 0 0 1 171 198.648h20a90.012 90.012 0 0 0-52.88-82M57.667 65.315a43.332 43.332 0 0 1 73.975-30.643 43.331 43.331 0 0 1-.002 61.283 43.333 43.333 0 0 1-73.973-30.64"
  })));
};
export default SvgLogin;